import { call, put, takeEvery } from "redux-saga/effects";
import {
  uploadToInstagramSuccess,
  uploadToInstagramFailed,
  uploadToFacebookSuccess,
  uploadToFacebookFailed,
  uploadToYouTubeSuccess,
  uploadToYouTubeFailed,
} from ".";
import { message } from "antd";
import {
  FACEBOOK_WEBHOOK_URL,
  INSTAGRAM_WEBHOOK_URL,
  YOUTUBE_WEBHOOK_URL,
} from "../../../utils";

// Saga to handle Instagram upload
export function* uploadInstagramMedia({ payload }: any): any {
  const { caption, videoUrl, language } = payload;
  const instagramPayload = {
    caption: caption,
    videoUrl: videoUrl,
    ...(language && { language }),
  };

  try {
    const data = yield call(() =>
      fetch(INSTAGRAM_WEBHOOK_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(instagramPayload),
      })
    );

    const parsedData = yield data.json();
    message.success("Video sent for Instagram publishing.");
    yield put(uploadToInstagramSuccess(parsedData));
  } catch (err) {
    message.error("Failed to upload to Instagram");
    yield put(uploadToInstagramFailed());
  }
}

// Saga to handle Facebook upload
export function* uploadFacebookMedia({ payload }: any): any {
  const { caption, videoUrl, language } = payload;
  const facebookPayload = {
    caption: caption,
    videoUrl: videoUrl,
    ...(language && { language }),
  };

  try {
    const data = yield call(() =>
      fetch(FACEBOOK_WEBHOOK_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(facebookPayload),
      })
    );

    const parsedData = yield data.json();
    message.success("Video sent for Facebook publishing.");
    yield put(uploadToFacebookSuccess(parsedData));
  } catch (err) {
    message.error("Failed to upload to Facebook");
    yield put(uploadToFacebookFailed());
  }
}

// Saga to handle YouTube upload
export function* uploadYouTubeVideo({ payload }: any): any {
  const { caption, videoUrl, language } = payload;
  const youtubePayload = {
    caption: caption,
    videoUrl: videoUrl,
    ...(language && { language }),
  };

  try {
    const data = yield call(() =>
      fetch(YOUTUBE_WEBHOOK_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(youtubePayload),
      })
    );

    const parsedData = yield data.json();
    message.success("Video sent for YouTube publishing.");
    yield put(uploadToYouTubeSuccess(parsedData));
  } catch (err) {
    message.error("Failed to upload to YouTube");
    yield put(uploadToYouTubeFailed());
  }
}

function* socialMediaSaga() {
  yield takeEvery("socialMedia/uploadToInstagram", uploadInstagramMedia);
  yield takeEvery("socialMedia/uploadToFacebook", uploadFacebookMedia);
  yield takeEvery("socialMedia/uploadToYouTube", uploadYouTubeVideo);
}

export default socialMediaSaga;
